import { BobaCurrency, BOBA_PRICE_OPTIONS } from '../boba-components'

export const getBobaPriceOptions = (currency: BobaCurrency) => {
  return BOBA_PRICE_OPTIONS[currency]
}
